import { useCallback, useEffect, useMemo, useState } from "react";
import { listBills } from "../../api/accounting";

// Hook مركزي: تحميل + إحصائيات + فلاتر (فرع/حالة/تصنيف/بحث).
export const useBills = () => {
  const [rows, setRows] = useState([]);
  const [status, setStatus] = useState("all");
  const [branchId, setBranchId] = useState("all");
  const [category, setCategory] = useState("all");
  const [query, setQuery] = useState("");

  const load = useCallback(async () => {
    setRows(await listBills({ status: "all" }));
  }, []);
  useEffect(() => { load(); }, [load]);

  const stats = useMemo(() => {
    const s = { overdue: 0, paid: 0, partial: 0, pending: 0,
                overdue_total: 0, paid_total: 0, partial_total: 0, pending_total: 0 };
    const today = new Date().toISOString().slice(0, 10);
    for (const b of rows) {
      const total = Number(b.total || 0);
      if (b.status === "paid")           { s.paid += 1; s.paid_total += total; }
      else if (b.status === "partial")   { s.partial += 1; s.partial_total += total - Number(b.paid_amount || 0); }
      else if (b.status === "pending_approval") { s.pending += 1; s.pending_total += total; }
      else if (b.status === "unpaid" && b.date <= today) { s.overdue += 1; s.overdue_total += total; }
    }
    return s;
  }, [rows]);

  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();
    return rows.filter((b) => {
      if (status !== "all" && b.status !== status) return false;
      if (branchId !== "all" && b.branch_id !== branchId) return false;
      if (category !== "all" && b.expense_account !== category) return false;
      if (!q) return true;
      const hay = `${b.supplier_invoice_no || ""} ${b.description || ""} ${b.entry_number || ""}`.toLowerCase();
      return hay.includes(q);
    });
  }, [rows, status, branchId, category, query]);

  return {
    rows: filtered, all: rows, stats, load,
    status, setStatus, branchId, setBranchId, category, setCategory, query, setQuery,
  };
};
